// عرض إشعارات Push أثناء فتح التطبيق (المقدّمة) عبر LocalNotifications،
// لأن iOS يكبت الإشعار افتراضياً عندما يكون التطبيق مفتوحاً — بدون هذا لا يظهر شيء عند الاختبار الداخلي.
import { isNative } from "./capacitor";

let wired = false;

export const initPushListeners = async () => {
  if (!isNative() || wired) return;
  const fm = (await import("@capacitor-firebase/messaging").catch(() => null))?.FirebaseMessaging;
  if (!fm) return;
  const ln = (await import("@capacitor/local-notifications").catch(() => null))?.LocalNotifications;
  wired = true;
  await ln?.requestPermissions().catch(() => {});
  await fm.addListener("notificationReceived", async (event) => {
    const n = event?.notification || {};
    const title = n.title || "HELCOO";
    const body = n.body || "";
    if (!ln) return;
    await ln
      .schedule({ notifications: [{ id: Date.now() % 2147483000, title, body, schedule: { at: new Date(Date.now() + 200) } }] })
      .catch(() => {});
  });
};
